import Dashboard from "../pages/dashboard/dashboard";
import DefaultLayout from "../layouts/home_layout/home_layout";
import UserManagementPage from "../pages/users/users";
import ViewRetailerApplicationForm from "../pages/retial_form/view_form/view_retail_application_form";
import routes from "../constants/routes.json";
import OverviewPage from "../pages/overview/overview_page";
import { useAuth } from "../hooks/useAuth";
import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { FullPageCircularProgress } from "../components/loader/full_page_loader";
import { useAuthStore } from "../store/authStore";

// Guest / Public
const RetailApplicationForm = lazy(
  () => import("../pages/retial_form/retail_application_form")
);

const VerifyPage = lazy(() => import("../pages/verify/verify_page"));
const LoginPage = lazy(() => import("../pages/login/login_page"));

const ProtectedRoute = lazy(() => import("./ProtectedRoute"));

const IndexRoutes = () => {
  const isAuthenticated = useAuth();
  const { userDetails } = useAuthStore();

  return (
    <Suspense fallback={<FullPageCircularProgress />}>
      <Routes>
        {/* All Public routes */}
        <Route
          path={routes.RETAIL_FORM}
          element={<RetailApplicationForm isEditForm={false} />}
        />
        <Route path={routes.VERIFY} element={<VerifyPage />} />

        {/* All not Authenticated routes */}
        {!isAuthenticated && (
          <Route path={routes.LOGIN} element={<LoginPage />} />
        )}

        {/* All Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<DefaultLayout />}>
            <Route path={routes.DASHBOARD} element={<Dashboard />} />
            <Route path={routes.OVERVIEW} element={<OverviewPage />} />
            <Route
              path={routes.EDIT_RETAIL_FORM}
              element={<RetailApplicationForm isEditForm={true} />}
            />
            {userDetails?.role === "admin" && (
              <Route path={routes.USERS} element={<UserManagementPage />} />
            )}
            <Route
              path={routes.VIEW_FORM}
              element={<ViewRetailerApplicationForm />}
            />
          </Route>
        </Route>

        {/* Catch-all route or other protected routes can be added here */}
        <Route
          path="*"
          element={
            <Navigate to={isAuthenticated ? routes.DASHBOARD : routes.LOGIN} />
          }
        />
      </Routes>
    </Suspense>
  );
};

export default IndexRoutes;
